<template>
  <div class="day-collection">
    <div class="left-align">
      <owal-header-banner
        v-sticky="{zIndex: 500, stickyTop: 1}"
        :title="date"
        secondary-button-title="Metrics"
        :subtitle="`${events.length} events loaded.`"
        :optional-view="OwalFilterPanel"
        :options="options"
        @secondaryButtonClick="showMetrics=true"
      />
      <owal-event-metrics-card
        v-if="showMetrics"
        :options="options"
        @close="showMetrics=false"
      />
      <owal-event-banner
        v-for="event in events"
        :key="`${event.id}${event.timestamp}`"
        :poster-frame="event.image"
        :full-frame="event.image"
        :unix-epoch-milliseconds="getUnixTimestamp(event.timestamp)"
        :dot-color="getDotColor(event.className)"
      >
        <div
          slot="content"
          style="width: 100%;"
        >
          <events-banner-slot
            style="padding-left: 1.5rem"
            :text="event.title"
            :camera-id="event.cameraId"
            :timestamp="event.timestamp"
          />
        </div>
      </owal-event-banner>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import OwalEventBanner from '@/libraries/owal-ui/banners/OwalEventBanner'
import OwalHeaderBanner from '@/libraries/owal-ui/banners/OwalHeaderBanner'
import EventsBannerSlot from './EventsBannerSlot'
import OwalEventMetricsCard from './OwalEventMetricsCard'
import OwalFilterPanel from './OwalFilterPanel'
import VueSticky from 'vue-sticky'

export default {
  name: 'DayCollection',
  components: { OwalEventBanner, OwalHeaderBanner, EventsBannerSlot, OwalEventMetricsCard },
  directives: {
    sticky: VueSticky,
  },
  props: ['date', 'events'],
  data () {
    return {
      OwalFilterPanel,
      showMetrics: false,
    }
  },
  computed: {
    options () {
      return {
        date: this.date,
        optionalButtonTitle: 'Filter',
      }
    },
  },
  methods: {
    getUnixTimestamp: function (timestamp) {
      return moment.utc(timestamp).valueOf()
    },
    getDotColor: function (className) {
      if (className === 'bicycle') {
        return 'rgb(244, 144, 213)'
      } else if (className === 'alarm') {
        return 'rgb(129, 247, 106)'
      } else if (className === 'person') {
        return 'rgb(244, 97, 105)'
      } else if (className === 'group') {
        return 'rgb(234, 172, 96)'
      } else if (className === 'pet') {
        return 'rgb(53, 181, 204)'
      }
    },
  },
}
</script>

<style scoped>
  .day-collection {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 1.5rem 1.5rem 0rem 1.5rem;
  }

  .scroll {
    padding-top: 40px;
    height: 100%;
    overflow-y: auto;
  }

  .left-align {
    display: flex;
    flex: initial;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 68.5714285714rem;
  }

  .left-align >>> .owal.header.banner.container .owal.header.banner.primary {
    padding-top: .8rem;
    padding-bottom: .8rem;
  }

</style>
